/*
  ProjectSearch.jsx — Search-and-select typeahead for projects.
  Extracted from CollectionPlanningPage.jsx (Feb 2026 refactor).
*/
import { useState, useEffect, useRef } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { fmt } from "./planningUtils";

export default function ProjectSearch({ projects, value, onChange, placeholder = "Search project..." }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = projects.find(p => p.id === value);
  const filtered = projects.filter(p => p.name.toLowerCase().includes(query.toLowerCase()));

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const statusPill = (status) => {
    if (!status || status === "active") return null;
    const map = { on_hold: ["On Hold", "bg-amber-100 text-amber-700"], completed: ["Completed", "bg-slate-100 text-slate-500"], cancelled: ["Cancelled", "bg-red-100 text-red-600"] };
    const [label, cls] = map[status] || [status, "bg-slate-100 text-slate-500"];
    return <span className={`text-[9px] font-semibold px-1.5 py-0.5 rounded ${cls}`}>{label}</span>;
  };

  return (
    <div className="relative" ref={ref}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input className="pl-9 text-sm" placeholder={placeholder} value={open ? query : (selected?.name || "")}
          onFocus={() => { setOpen(true); setQuery(""); }}
          onChange={e => { setQuery(e.target.value); setOpen(true); }} />
      </div>
      {open && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-lg shadow-lg max-h-56 overflow-y-auto">
          {filtered.length === 0 ? <p className="p-3 text-xs text-slate-400">No projects found</p> : filtered.map(p => (
            <button key={p.id} onClick={() => { onChange(p.id); setQuery(""); setOpen(false); }}
              className="w-full text-left px-3 py-2 hover:bg-blue-50 text-sm flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 min-w-0">
                <span className="font-medium text-slate-800 truncate">{p.name}</span>
                {statusPill(p.status)}
                {p.currency === "USD" && <span className="text-[9px] font-semibold px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-700">USD</span>}
              </div>
              <span className="text-[10px] text-slate-400 whitespace-nowrap">Due: {fmt(p.outstanding || 0)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
